module.exports = __webpack_public_path__ + "img/layer-1.84b90a3c.png";